import { LiquidityScenarioTransaction, TransactionStatus } from "@/types/liquidity-api"
import dayjs from "dayjs"
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

// Enable the dayJs plugins
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export const filterActiveTransactions = (transactions: LiquidityScenarioTransaction[], dateFrom: dayjs.Dayjs, dateTo: dayjs.Dayjs): LiquidityScenarioTransaction[] => {
	return transactions
	.filter(t => t.status === TransactionStatus.Pending)
	.filter(t => {
		const date = dayjs(t.transactionDate)
		return date.isSameOrAfter(dateFrom) && date.isSameOrBefore(dateTo);
	})
}